export const CheckedIconSvg = () => (
  <svg
    data-testid="checked-icon-svg"
    xmlns="http://www.w3.org/2000/svg"
    className="absolute pointer-events-none"
    width={24}
    height={24}
    fill="none"
  >
    <path
      fill="#fff"
      d="m8.795 15.875-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41-10.59 10.58Z"
    />
  </svg>
)
export default CheckedIconSvg
